/**
 * Generation Overlay - Homepage
 * Uses the unified GenerationLoader component
 */

import type { ProgressPhase, MarketInsights, PhaseStatus, GenerationErrorCode } from "@/client/hooks/use-generation-stream";
import { GenerationLoader } from "@/client/components/generation-loader";

type GenerationOverlayProps = {
  isOpen: boolean;
  onClose: () => void;
  formData: {
    jobRole: string;
    country: string;
    jobUrl?: string;
  };
  progress: number;
  currentPhase: ProgressPhase | null;
  currentMessage: string;
  isThinking?: boolean;
  error: string | null;
  errorCode?: GenerationErrorCode | null;
  insights?: MarketInsights | null;
  phases?: Record<ProgressPhase, PhaseStatus>;
  pipelineStartTime?: number | null;
};

export const GenerationOverlay = ({
  isOpen,
  onClose,
  formData,
  progress,
  currentPhase,
  currentMessage,
  isThinking,
  error,
  errorCode,
  insights,
  phases,
  pipelineStartTime,
}: GenerationOverlayProps) => {
  return (
    <GenerationLoader
      isOpen={isOpen}
      onClose={onClose}
      formData={formData}
      progress={progress}
      currentPhase={currentPhase}
      currentMessage={currentMessage}
      isThinking={isThinking}
      error={error}
      errorCode={errorCode}
      insights={insights}
      phases={phases}
      pipelineStartTime={pipelineStartTime}
    />
  );
};
